import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import axios from 'axios';
import i18n from './i18n';
import './plugins/vuetify-money.js';
import { baseURL } from '@/constants';

//axios.defaults.baseURL = 'http://172.16.1.89:9539'; //Para pruebas en UIA
//axios.defaults.baseURL = 'http://arqibero.gtsf.com.mx'; //Para pruebas en Jocoque
axios.defaults.baseURL = baseURL;
//axios.defaults.baseURL = 'http://192.168.1.66:9816';
//baseURL: 'http://172.22.128.136:9539'

Vue.config.productionTip = false;

//Para ver la versión de lodash:
/*const _ = require('lodash');
const ver = _.VERSION;
console.log(ver);*/

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
